import React from 'react';
import { PatternFormat  } from 'react-number-format';
import TextField from '@material-ui/core/TextField';

export default function TimeTextField(props) {
    return (
        <PatternFormat
            customInput={TextField}
            label={props.label}
            onChange={props.handleChange}
            onFocus={props.onFocus}
            onBlur={props.onBlur}
            name={props.name}
            id={props.id}
            placeholder={props.placeholder}
            value={props.value}
            disabled={props.disabled}
            format="##:##"
            className={props.className}
        />
    );
}